export enum BarcodeStatusEnum {
  SCANNED = 'SCANNED',
  REMOVED = 'REMOVED',
}
